<template>
    <!-- sign up info -->
    <ModalPopup
        ref="modalPopupSubmitRef"
        :isShowCloseButton="isShowCloseButton"
    >
        <div class="display-flex-bc flex-col modal-confirmation__body">
            <div class="fav-login-tips__title" @click="handleBodyClick($event)">
                {{ $t(title) }}
            </div>
            <div class="mb-15rem font-m fav-login-tips__text">
                {{ message }}
            </div>
            <div class="w-100">
                <slot name="default">
                    <router-link
                        :to="{
                            name: 'signup',
                            query: {
                                callBackUrl: pathName
                                    ? pathName
                                    : currentPathName,
                            },
                        }"
                    >
                        <button
                            class="btn btn-aspn-default mb-05rem w-100 nav-pill selected"
                        >
                            {{ $t("JOIN_NOW") }}
                        </button>
                    </router-link>
                    <router-link
                        :to="{
                            name: 'signin',
                            query: {
                                callBackUrl: pathName
                                    ? pathName
                                    : currentPathName,
                            },
                        }"
                    >
                        <button class="btn btn-aspn-default w-100 nav-pill">
                            {{ $t("SIGN_IN") }}
                        </button>
                    </router-link>
                </slot>
            </div>
        </div>
    </ModalPopup>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import ModalPopup from "@/components/modal/ModalPopup.vue";

export default {
    props: {
        message: String,
        pathName: String,
        title: String,
        isShowCloseButton: {
            type: Boolean,
            default: true,
        },
    },
    components: {
        ModalPopup,
    },

    computed: {
        ...mapGetters(["isMobile", "currentPathName"]),
    },
    methods: {
        handleOpen() {
            this.$refs.modalPopupSubmitRef.handleOpen();
        },
        handleClose() {
            this.$refs.modalPopupSubmitRef.handleClose();
        },
    },
};
</script>

<style scoped>
.fav-login-tips__title {
    color: var(--color-text-default-default);
    font-size: var(--typography-heading-size-extra-small);
    padding-bottom: 24px;
    font-family: var(--weight-600);
}
.nav-pill {
    font-size: 16px;
    letter-spacing: 0.64px;
}
.fav-login-tips__text {
    margin-bottom: 24px;
    font-size: 16px;
    color: var(--color-text-default-default);
    letter-spacing: 0.64px;
}
</style>
